import { Edit, Form, Input, useForm } from '@pankod/refine-antd'
import { useNavigation, useResource } from '@pankod/refine-core'
import { Resources, ValidationRules } from 'consts'
import { useParams } from 'hooks'
import { Provider } from 'interfaces'

export const ProvidersEdit: React.FC = () => {
  const { show } = useNavigation()
  const params = useParams()
  const { resource } = useResource()
  const { formProps, saveButtonProps, queryResult } = useForm<Provider>({
    id: params.id,
    resource: Resources.PROVIDERS,
    redirect: false,
    onMutationSuccess: () => {
      show(resource.route, params.id)
    },
    metaData: {
      populate: {
        meta: '*',
        shared_provider: {
          populate: ['logo'],
        },
      },
    },
  })

  const record = queryResult?.data?.data

  return (
    <Edit
      canDelete
      deleteButtonProps={{
        resourceNameOrRouteName: Resources.PROVIDERS,
        recordItemId: params.id,
      }}
      saveButtonProps={saveButtonProps}
      title={`Edit ${record?.shared_provider.title} Page`}
      isLoading={queryResult?.isLoading}
    >
      <Form {...formProps} layout="vertical">
        <Form.Item
          label="Meta title"
          name={['meta', 'title']}
          rules={ValidationRules.META_TITLE}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Meta description"
          name={['meta', 'description']}
          rules={ValidationRules.META_DESCRIPTION}
        >
          <Input />
        </Form.Item>
        <Form.Item label="Welcome Block Title" name="welcome_block_title">
          <Input />
        </Form.Item>
        <Form.Item label="Text Block - Welcome" name="welcome_block_text">
          <Input.TextArea rows={8} />
        </Form.Item>
        <Form.Item label="About Block Title" name="about_block_title">
          <Input />
        </Form.Item>
        <Form.Item label="Text Block - About" name="about_block_description">
          <Input.TextArea rows={8} />
        </Form.Item>
      </Form>
    </Edit>
  )
}
